// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'root-container',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'tray-container',
      type: 'Container',
      name: 'trayContainer',
      className: '',
      x: -220,
      y: 0,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 40
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'root-container'
    },
    {
      id: '6b6a652e-774e-4abe-8aeb-26029014ff25',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 220,
      height: 80,
      leftWidth: 4,
      topHeight: 0,
      rightWidth: 41,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Tray_9Slice_4x0x41x0',
      parent: 'tray-container'
    },
    {
      id: 'tray-background',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 35,
      y: 9,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 141,
      height: 55,
      leftWidth: 28,
      topHeight: 0,
      rightWidth: 28,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Tray_Amount_Background_9Slice_28x0x28x0',
      parent: 'tray-container'
    },
    {
      id: '0951c37e-1d1c-424b-9570-386063818268',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 120,
      y: 39,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '75',
      localize: false,
      maxWidth: 108,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x870066',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'tray-container'
    },
    {
      id: 'animation-target-slot',
      type: 'Container',
      name: 'animationTargetSlot',
      className: '',
      x: 126,
      y: 35,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'tray-container'
    },
    {
      id: 'token-icon-slot',
      type: 'Container',
      name: 'tokenIconSlot',
      className: '',
      x: 52,
      y: 36,
      scale: {
        x: 0.85,
        y: 0.85
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'tray-container'
    },
    {
      id: '32c6c41e-14b7-4d8a-a930-95c441850e0a',
      type: 'Container',
      name: 'particleSlot',
      className: '',
      x: 52,
      y: 36,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'tray-container'
    },
    {
      id: 'bb09dfd4-d5f9-46b8-b2a1-e96be4b8056d',
      type: 'Sprite',
      name: 'arrow',
      className: '',
      x: 200,
      y: 38,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -180,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -50,
        y: -60,
        width: 70,
        height: 120
      },
      texture: 'Reward_Tray_Arrow_9Slice_28x0x28x0',
      parent: 'tray-container'
    }
  ],
  x: 0,
  y: 0,
  width: 280,
  height: 120,
  version: '1.0.0',
  animations: [
    {
      id: '7ef2754d-1815-404b-bb53-06ffd533323a',
      name: 'Open',
      playingSpeed: 1,
      totalDuration: 180,
      blocks: [
        {
          id: 'ba0fa83a-837c-47e6-a667-ca9a7d00d6c0',
          type: 'Tween',
          name: 'tweenPos0_trayContainer',
          duration: 150,
          track: 4,
          target: {
            x: 0
          },
          startAt: 0,
          sourceName: 'trayContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a49aba1a-7ed0-4b04-aa19-c1bcf27355e7',
          type: 'Tween',
          name: 'tweenAngle0_arrow',
          duration: 150,
          track: 5,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'arrow',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '64875d00-388e-4e16-8478-127e2702e1fa',
      name: 'Close',
      playingSpeed: 1,
      totalDuration: 180,
      blocks: [
        {
          id: 'ba0fa83a-837c-47e6-a667-ca9a7d00d6c0',
          type: 'Tween',
          name: 'tweenPos0_trayContainer',
          duration: 150,
          track: 4,
          target: {
            x: -220
          },
          startAt: 0,
          sourceName: 'trayContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a49aba1a-7ed0-4b04-aa19-c1bcf27355e7',
          type: 'Tween',
          name: 'tweenAngle0_arrow',
          duration: 150,
          track: 5,
          target: {
            angle: -180
          },
          startAt: 0,
          sourceName: 'arrow',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class CollectEventInGameTrayLayout {
  static raw = raw;
  root!: Container;
  trayContainer!: Container;
  amountText!: Text;
  animationTargetSlot!: Container;
  tokenIconSlot!: Container;
  particleSlot!: Container;
  arrow!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Open {
  Layout: {
    trayContainer: object;
    arrow: object;
  };

  BlockTypeByName: {
    tweenPos0_trayContainer: object;
    tweenAngle0_arrow: object;
  };

  flowData = raw.animations[0];
}

export abstract class Close {
  Layout: {
    trayContainer: object;
    arrow: object;
  };

  BlockTypeByName: {
    tweenPos0_trayContainer: object;
    tweenAngle0_arrow: object;
  };

  flowData = raw.animations[1];
}
